export const Listmovie = [
  {
    id: "9d96e704-293e-4bf9-8aa0-e3c040ba52f3",
    nom: "Face/Off => Volte Face",
    description:
      "Castor Troy, dangereux terroriste, est tombé dans le coma à la suite d'un affrontement avec Sean Archer, agent de la CIA. Grâce à une intervention chirurgicale, Archer prend le visage de Troy pour faire avouer au frère de ce dernier l'emplacement d'une bombe. Cependant Troy sort du coma et prend à son tour le visage d'Archer.",
    image:
      "https://fr.web.img3.acsta.net/medias/nmedia/18/97/55/80/20535753.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/K-gncct2TX8",
    categorie: "Action, Thriller",
    star: "8/10",
    exit_date: "27 août 1997",
    realisateur: "John Woo",
    acteurs_nom: [
      "Nicolas Cage",
      "John Travolta",
      "Gina Gershon",
      "Dominique Swain",
      "Joan Allen",
    ],
    acteurs_image: [
      "https://gal.img.pmdstatic.net/fit/http.3A.2F.2Fprd2-bone-image.2Es3-website-eu-west-1.2Eamazonaws.2Ecom.2Fgal.2Fvar.2Fgal.2Fstorage.2Fimages.2Fmedia.2Fimages.2Factu.2Fphotos_on_ne_parle_que_de_ca.2Fphotos_877.2Fnicolas_cage_2.2F1359363-1-fre-FR.2Fnicolas_cage_2.2Ejpg/480x480/quality/80/nicolas-cage-accuse-de-violences-sur-son-enfant.jpg",
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/John_T_color_01.jpg/200px-John_T_color_01.jpg",
      "https://i.pinimg.com/originals/34/03/5b/34035b497fb1ffea4c1f625c5a57ede7.jpg",
      "https://images-na.ssl-images-amazon.com/images/I/41Kn0DC99kL._AC_.jpg",
      "https://i.pinimg.com/originals/cb/5c/0f/cb5c0f5c085bf0c83dd976dedeac57e7.jpg",
    ],
    suite: "",
  },
  {
    id: "cc4baf40-4402-4697-ac3e-d1b101870cd6",
    nom: "Gunman",
    description:
      "Ancien des forces spéciales et tueur à gages repenti, Jim Terrier a décidé de tout quitter pour se reconvertir dans l'humanitaire en Afrique. Il travaille à présent pour le compte d'une ONG en République démocratique du Congo, un pays dévasté par la guerre, la famine, la corruption, mais aussi par les multinationales qui pillent les ressources naturelles. Là, il a fait la rencontre d'Annie, la femme de sa vie.",
    image: "https://fr.web.img6.acsta.net/pictures/15/06/23/09/06/518727.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/HyNJ6L0mDbs",
    categorie: "Action, Drame",
    star: "10/10",
    exit_date: "16 février 2015",
    realisateur: "Pierre Morel",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "3fab1f7d-f03c-400c-aa5f-8fc222df3fe5",
    nom: "Shoot Caller 'La survie à un prix' ",
    description:
      "Jacob Harlon est un homme d'affaires à succès et un père de famille épanoui jusqu'au jour où il tue son meilleur ami dans un accident de la route après une soirée trop arrosée. Envoyé dans une prison de haute sécurité, il doit se soumettre aux rites de passage et devient Money, un gangster violent et sans pitié. A sa sortie, surveillé par la police, ses anciens codétenus l'obligent à commettre un dernier crime.",
    image: "https://fr.web.img5.acsta.net/pictures/17/11/29/09/38/0843977.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/Zp9Th98GpuU",
    categorie: "Action, Criminel, Thriller",
    star: "10/10",
    exit_date: "13 juillet 2017",
    realisateur: "Ric Roman Waugh",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "39414f9f-bce0-424a-a6c9-9b92c12759fd",
    nom: "Good Kill",
    description:
      "Le major Thomas Egan, l'ancien pilote de chasse s'est reconverti en pilote de drones avec lequel il tue des terroristes en Afghanistan, au Pakistan et au Yémen sans quitter le désert de Las Vegas. Il remet sa mission en question.",
    image: "https://fr.web.img5.acsta.net/pictures/15/03/13/19/03/164909.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/5rQG_tc74Nw",
    categorie: "Action, Guerre, Drame",
    star: "9/10",
    exit_date: "15 mai 2015",
    realisateur: "Andrew Niccol",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "da15288b-73ad-43af-81d1-3da27def436d",
    nom: "Nuit blanche",
    description:
      "Vincent, agent des stups, saisit un sac de cocaïne appartenant à de gros trafiquants. Pour le faire plier, ces derniers décident de prendre son fils en otage. Ce sera donc le sac contre le fils. C'est dans une immense boîte de nuit tenue par des mafieux que l'échange doit se faire.",
    image:
      "https://fr.web.img4.acsta.net/medias/nmedia/18/85/93/47/19821710.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/Fe-B721H7pQ",
    categorie: "Action, Thriller",
    star: "9/10",
    exit_date: "16 novembre 2011",
    realisateur: "Frédéric Jardin",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "7abe4f2f-db82-4394-a4bb-6658b637b9d7",
    nom: "Colt 45",
    description:
      "Armurier et instructeur de tir à la Police Nationale, Vincent Milès est expert en tir de combat. À seulement 25 ans, ses compétences sont enviées par les élites du monde entier mais Vincent refuse obstinément d'intégrer une brigade de terrain.",
    image: "https://fr.web.img2.acsta.net/pictures/14/06/27/14/02/024157.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/hb-dRRZ8UFw",
    categorie: "Action, Thriller",
    star: "10/10",
    exit_date: "1 octobre 2014",
    realisateur: "Fabrice Du Welz, Frédéric Forestier",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "4fd9aaee-a355-4a2d-9aff-e594280ad893",
    nom: "Un 22 juillet",
    description:
      "La véritable histoire de l'attaque terroriste la plus meurtrière jamais perpétrée en Norvège. Le 22 juillet 2011, 77 personnes sont tuées lorsqu'un ultranationaliste d'extrême droite fait exploser une bombe artisanale placée dans une voiture à Oslo avant de commettre une fusillade dans un camp d'été de jeunes.",
    image: "https://fr.web.img3.acsta.net/pictures/18/10/02/14/59/3147085.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/Kcgt_TK0XnE?start=7",
    categorie: "Drame/Criminel",
    star: "10/10",
    exit_date: "10 octobre 2018",
    realisateur: "Paul Greengrass",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "49daf82e-2ef2-4d99-b2c6-35b55691a8cb",
    nom: "Man on Fire",
    description:
      "John W. Creasy, un ex-agent de la CIA devenu alcoolique, se fait engager comme garde du corps par Samuel Ramos, membre d'une famille bourgeoise de Mexico, afin d'empêcher un éventuel rapt de sa fille Pita. Les enlèvements sont en effet monnaie courante dans toute l'Amérique latine. Le garde du corps, au bord du suicide, exerce froidement son métier dans un premier temps, rejetant la fillette de neuf ans qui cherche en lui un ami.",
    image:
      "https://fr.web.img4.acsta.net/medias/nmedia/18/35/32/57/18393493.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/eDDh50B6kA4",
    categorie: "Action, Drame",
    star: "10/10",
    exit_date: "13 octobre 2004",
    realisateur: "Tony Scott",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "74b00e5b-e4ec-442d-a496-e36018b00d05",
    nom: "Safe House",
    description:
      "Tobin Frost est le traître le plus haï et le plus redouté de la CIA. Après avoir échappé au contre-espionnage pendant près de dix ans, il est découvert et sa sécurité est assurée par un jeune bleu désirant faire ses preuves. Une relation précaire s'établit entre le débutant et le renégat endurci. Cependant, Frost, manipulateur-né, réserve quelques surprises à son candide protecteur.",
    image:
      "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcSz0zKLFHTh3cKpwrYNghDaQI15W4KiKQyKreH6WlQit1BEjfld",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/qRGFt59P6k8",
    categorie: "Action, Thriller",
    star: "8/10",
    exit_date: "22 février 2012",
    realisateur: "Daniel Espinosa",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "fec67da4-8ca5-4e62-9073-cda486351631",
    nom: "Heat",
    description:
      "La bande de Neil McCauley à laquelle est venu se greffer Waingro, une nouvelle recrue, attaque un fourgon blindé pour s'emparer d'une somme importante en obligations. Cependant, ce dernier tue froidement l'un des convoyeurs et Chris Shiherlis se retrouve obligé de terminer le travail. Neil tente d'éliminer Waingro, mais celui-ci parvient à s'échapper. Parallèlement, le lieutenant Vincent Hanna mène l'enquête.",
    image:
      "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcQco6BjenSkCto6Jo6TwW9He8NpM_FSz16wbrgu3IyEZTWXd9Ic",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/Xl7X4Pf3PTY?start=15",
    categorie: "Action, Thriller",
    star: "10/10",
    exit_date: "14 février 1996",
    realisateur: "Michael Mann",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "35579ffd-1f5b-4b16-bc97-dfa6ae23415c",
    nom: "Law Abiding Citizen",
    description:
      "Dix ans après le meurtre de sa femme et sa fille, un homme se dresse contre le procureur en charge du procès des meurtriers, pour obtenir lui-même la justice. Sa vengeance menace tout aussi bien l'homme qui leur a accordé la clémence, que le système et la ville elle-même.",
    image:
      "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcQf09K1l0vFd5UVNnP_Y4Cwxz2dTv3b2yk4T_HYTP7q8W5cMXyd",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/2uZOxgUSeHY",
    categorie: "Thriller, Drame",
    star: "10/10",
    exit_date: "2 juin 2010",
    realisateur: "F. Gary Gray",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "5f5e2e76-a2bb-4d52-a787-87fe4cc5cbac",
    nom: "The Social Network",
    description:
      "Une soirée bien arrosée d'octobre 2003, Mark Zuckerberg, un étudiant qui vient de se faire plaquer par sa petite amie, pirate le système informatique de l'université deHarvard pour créer un site, une base de données de toutes les filles du campus.",
    image:
      "https://media.senscritique.com/media/000004859521/source_big/The_Social_Network_Bande_Originale.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/K3Nss06OFMw",
    categorie: "Drame, Histoire",
    star: "10/10",
    exit_date: " 27 octobre 2010",
    realisateur: "David Fincher",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "15d10f99-2744-4e21-a02c-ad5d374ed321",
    nom: "The Town",
    description:
      "Doug MacRay et James Coughlin sont deux amis d'enfance ayant grandi dans l'arrière-cour de Boston. A la tête d'un groupe de braqueurs de banques, ils prennent en otage une jeune femme au cours d'un hold-up. Après l'avoir relâchée, Doug tombe sous son charme, la suit et entame une relation avec elle. Pris dans un étau entre sa famille criminelle et celle qu'il pourrait fonder auprès de Claire, Doug va devoir faire un choix.",
    image:
      "https://fr.web.img5.acsta.net/medias/nmedia/18/74/18/81/19489279.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/FMfVh1H6Q3U",
    categorie: "Thriller, Policier",
    star: "10/10",
    exit_date: "2010",
    realisateur: "Ben Affleck",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "90b29a3b-6cce-4538-96d5-a80280eedec5",
    nom: "Sand Castle",
    description:
      "Sand Castle ou Château de sable au Québec est un film de guerre britannique réalisé par Fernando Coimbra, sorti en 2017 sur Netflix.",
    image: "https://fr.web.img4.acsta.net/pictures/17/10/24/15/02/4552870.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/-tBgC7StumQ",
    categorie: "Guerre, Drame",
    star: "8/10",
    exit_date: "14 avril 2017",
    realisateur: "Mark Gordon",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "6590aaef-81ac-472c-a9a6-4ab24ff0c580",
    nom: "Beasts Of No Nation",
    description:
      "Quand la guerre civile déchire sa famille, un jeune Africain de l'Ouest est contraint d'intégrer un groupe de combattants mercenaires et devient alors un enfant soldat.",
    image:
      "https://www.lorhkan.com/wp-content/uploads/2016/05/Beasts-of-no-nation-affiche.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/ZksNLr4rubc",
    categorie: "Guerre, Drame",
    star: "8/10",
    exit_date: "16 octobre 2015",
    realisateur: "",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "f887e2f4-f5ff-4c27-9551-d8066175f19d",
    nom: "L'Attaque du métro 123 (The Taking of Pelham 123)",
    description:
      "Walter Garber est aiguilleur du métro à New York. Comme chaque jour, il veille au bon déroulement du trafic. Lorsque la rame Pelham 123 s'immobilise sans explication, c'est le début du cauchemar. Ryder, un criminel aussi intelligent qu'audacieux, a pris en otage les passagers. Avec ses trois complices lourdement armés, il menace d'exécuter les voyageurs si une énorme rançon ne lui est pas versée très vite.",
    image:
      "https://img2.cdn.cinoche.com/images/0435a5bb8edcc74f03849804a3ab89cf.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/gNacf7ueIi8",
    categorie: "Thriller, Action",
    star: "7/10",
    exit_date: "4 juin 2009",
    realisateur: "Tony Scott",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "6bf27e55-3871-445f-885c-b20eb6557591",
    nom: "À la recherche du bonheur",
    description:
      "Représentant de commerce, Chris Gardner a du mal à gagner sa vie. Il jongle pour s'en sortir, mais sa compagne supporte de moins en moins leur précarité. Elle finit par quitter Chris et leur petit garçon de cinq ans, Christopher. Désormais seul responsable de son fils, Chris se démène pour décrocher un job, sans succès. Lorsqu'il obtient finalement un stage dans une prestigieuse firme de courtage, il se donne à fond.",
    image:
      "https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcTm0Qz4R7uV295Kk4SbdbxUBWnkqkQdpDZVaatd7m_5zYlXsWYK",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/fphWEtwhOdI",
    categorie: "Drame",
    star: "8/10",
    exit_date: "7 février 2007",
    realisateur: "Gabriele Muccino",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "66c00661-1314-4c29-800c-8941a9a23ab8",
    nom: "Dead Man Down",
    description:
      "Victor est le bras droit d'Alphonse, un caïd new-yorkais. Quelqu'un s'en prend à leur gang, dont les hommes sont abattus les uns après les autres et l'assassin multiplie les messages de menace. Espérant s'attirer les faveurs d'Alphonse, Darcy, un ami de Victor, se lance sur les traces du tueur. Lorsque Victor fait la connaissance de Béatrice, une Française qui vit avec sa mère, Valentine, il est tout de suite attiré.",
    image:
      "https://www.panorama-cinema.com/V2/images/critique/critique970/affiche1.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/gu6veYjtqmI",
    categorie: "Action, Thriller",
    star: "10/10",
    exit_date: "2013",
    realisateur: "Niels Arden Oplev",
    acteurs_nom: [],
    acteurs_image: [],
    suite: "",
  },
  {
    id: "6e2bd75b-362f-41b8-a69d-629e4ad70c27",
    nom: "Capitaine Phillips",
    description:
      "Capitaine Phillips retrace l'histoire vraie de la prise d'otages du navire de marine marchande américain Maersk Alabama, menée en 2009 par des pirates somaliens. La relation qui s'instaure entre le capitaine Richard Phillips, commandant du bateau, et Muse, le chef des pirates somaliens, qui le prend en otage, est au coeur du récit. Les deux hommes sont inévitablement amenés à s'affronter lorsque Muse et son équipe s'attaquent au navire désarmé de Phillips.",
    image:
      "https://fr.web.img2.acsta.net/pictures/210/407/21040713_20130919122153669.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/zxkWySF6RFw",
    categorie: "Thriller, Action",
    star: "9.5/10",
    exit_date: "20 novembre 2013",
    realisateur: "Paul Greengrass",
    acteurs_nom: [
      "Tom Hanks",
      "Barkhad Abdi",
      "Michael Chernus",
      "Chris Mulkey",
      "Faysal Ahmed",
    ],
    acteurs_image: [
      "https://upload.wikimedia.org/wikipedia/commons/a/a9/Tom_Hanks_TIFF_2019.jpg",
      "https://cristallebeaute.files.wordpress.com/2014/01/image.jpg",
      "https://www.gstatic.com/tv/thumb/persons/549688/549688_v9_bb.jpg",
      "https://www.rsdoublage.com/acteurs/mulkey_chris.jpg",
      "https://www.gstatic.com/tv/thumb/persons/737147/737147_v9_ba.jpg",
    ],
    suite: "",
  },
  {
    id: "19f89850-79c0-4a61-a0f3-824792145e09",
    nom: "Sicario",
    description: "La zone frontalière entre les États-Unis et le Mexique est devenue un territoire de non-droit. Kate, une jeune recrue idéaliste du FBI, y est enrôlée pour aider un groupe d'intervention d'élite dirigé par un agent du gouvernement dans la lutte contre le trafic de drogues. Menée par un consultant énigmatique, l'équipe se lance dans un périple clandestin, obligeant Kate à remettre en question ses convictions pour pouvoir survivre.",
    image: "https://fr.web.img4.acsta.net/pictures/15/07/29/17/08/261485.jpg",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/b840JwYY7jg",
    categorie: "Thriller, Crime, Action",
    star: "10/10",
    exit_date: "17 septembre 2015",
    realisateur: "Denis Villeneuve",
    acteurs_nom: [
      "Benicio del Toro",
      "Josh Brolin",
      "Emily Blunt",
      "Jeffrey Donovan",
      "Jon Bernthal",
    ],
    acteurs_image: [
      "http://t0.gstatic.com/images?q=tbn:ANd9GcQdbPs6eCJwv4yB_S_5oMUOhK-PMmP8YghLVq6HEQxi_lIZGQwdW1zSQDIRgmUJ",
    "http://t2.gstatic.com/images?q=tbn:ANd9GcRAy4WtOKNyIMpDeGNsotq_tChss8VSpoBz-nT_IrYMVQQcRZk_HmQdABkyYFO9",
    "http://t2.gstatic.com/images?q=tbn:ANd9GcSr67N3pkIhbX77Ozfmwgif_x8l0ZzhxwGcAjgBQnjnKbXFd45WuDj6deXqdOPI",
    "http://t3.gstatic.com/images?q=tbn:ANd9GcRSiv0vZVAect-Xeq5zaBnQj0SiFVUpm5PraAxJUNGu5yLo78uqGzLdJKLrfypz",
    "http://t0.gstatic.com/images?q=tbn:ANd9GcQMHcBR9FGOkemhHin0LDRJt0tza1A9hiQCj9SOZpbxaF_IIpPKB3yA66XqgusX",
  ],
    suite: "Sicario 2",
  },
  {
    id: "07be02ae-851e-4a25-a7b4-0d12784a9b50",
    nom: "Sicario : La Guerre des cartels",
    description: "Les cartels mexicains font régner la terreur à la frontière entre le Mexique et les États-Unis. Rien ni personne ne semble pouvoir les contrer. L'agent fédéral Matt Graver fait de nouveau appel au mystérieux Alejandro pour enlever la jeune Isabela Reyes, fille du baron d'un des plus gros cartels, afin de déclencher une guerre fratricide entre les gangs. La situation dégénère et la jeune fille devient un risque potentiel dont il faut se débarrasser.",
    image: "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcTboe6hRupQo9pN4A4c5SknJZ_1dbVsLQRp7xTKdF9FSvzWTMhV",
    alt: "Image du film",
    youtube: "https://www.youtube.com/embed/VVBGsysg5OI",
    categorie: "Action, Drame",
    star: "10/10",
    exit_date: "11 juin 2018",
    realisateur: "Stefano Sollima",
    acteurs_nom: [
      "Benicio del Toro",
      "Josh Brolin",
      "Isabela Moner",
      "Jeffrey Donovan",
      "Catherine Keener",
    ],
    acteurs_image: [
      "http://t0.gstatic.com/images?q=tbn:ANd9GcQdbPs6eCJwv4yB_S_5oMUOhK-PMmP8YghLVq6HEQxi_lIZGQwdW1zSQDIRgmUJ",
      "http://t2.gstatic.com/images?q=tbn:ANd9GcRAy4WtOKNyIMpDeGNsotq_tChss8VSpoBz-nT_IrYMVQQcRZk_HmQdABkyYFO9",
      "http://www.gstatic.com/tv/thumb/persons/763128/763128_v9_bb.jpg",
      "http://t3.gstatic.com/images?q=tbn:ANd9GcRSiv0vZVAect-Xeq5zaBnQj0SiFVUpm5PraAxJUNGu5yLo78uqGzLdJKLrfypz",
      "https://www.irishtimes.com/polopoly_fs/1.3425489.1520949421!/image/image.jpg_gen/derivatives/ratio_1x1_w1200/image.jpg",
    ],
    suite: "",
  },
    // {
  //   id: "",
  //   nom: "",
  //   description: "",
  //   image: "",
  //   alt: "Image du film",
  //   youtube: "https://www.youtube.com/embed/",
  //   categorie: "",
  //   star: "",
  //   exit_date: "",
  //   realisateur: "",
  //   acteurs_nom: [],
  //   acteurs_image: [],
  //   suite: "",
  // },
];
